<template>
<div class="chapter">
<div class="inner_page">
<div aria-label="1" epub:type="pagebreak" id="page1" role="doc-pagebreak">
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer000">
<p class="dedication">For Ulla, first in a new generation of readers </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?0a0dfde1